// src/components/Navbar.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Drawer, List, ListItem, ListItemText, IconButton, Box } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

const Navbar = () => {
  const [open, setOpen] = useState(false);

  const toggleDrawer = (isOpen) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setOpen(isOpen);
  };

  const list = () => (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List>
        <ListItem sx={{borderBottom: 1, borderColor: 'var(--text-color)'}} button component={Link} to="/">
          <ListItemText primary="Home" sx={{ color: 'var(--text-color)' }} />
        </ListItem>
        <ListItem sx={{borderBottom: 1, borderColor: 'var(--text-color)'}} button component={Link} to="/reporting">
          <ListItemText primary="Reporting" sx={{ color: 'var(--text-color)' }} />
        </ListItem>
      </List>
    </Box>
  );

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
      }}
    >
      <IconButton
        aria-label="menu"
        onClick={toggleDrawer(true)}
        sx={{ color: 'var(--background-color)', }}
      >
        <MenuIcon />
      </IconButton>
      <Drawer
        anchor="left"
        open={open}
        onClose={toggleDrawer(false)}
        sx={{
          '& .MuiDrawer-paper': {
            width: 200, // Set custom width for the drawer
            backgroundColor: 'var(--background-color)', // Set drawer background to black
          },
        }}
      >
        {list()}
      </Drawer>
    </Box>
  );
};

export default Navbar;
